import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const useRTL = () => {
  const { i18n } = useTranslation()

  useEffect(() => {
    const isRTL = i18n.language === 'ar'

    // Update document direction
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr'
    document.documentElement.lang = i18n.language

    // Add RTL-specific CSS classes
    if (isRTL) {
      document.documentElement.classList.add('rtl')
    } else {
      document.documentElement.classList.remove('rtl')
    }
  }, [i18n.language])

  return {
    isRTL: i18n.language === 'ar',
    language: i18n.language,
  }
}
